(function () {
  'use strict';

  var SCRIPT_ID = 'upcart-cart-trust-script';
  var BADGE_ID = 'upcart-cart-trust-badge';
  var SAVINGS_ID = 'upcart-cart-savings';

  if (document.getElementById(SCRIPT_ID)) return;

  var scriptIdentifier = document.createElement('div');
  scriptIdentifier.id = SCRIPT_ID;
  scriptIdentifier.style.display = 'none';
  document.head.appendChild(scriptIdentifier);

  var observer = null;
  var drawerFinder = null;
  var debounceTimer = null;
  var isRendering = false;
  var trustConfig = window.UPCART_CART_TRUST || {};
  var trustImageUrl = trustConfig.imageUrl || '';
  var moneyFormat = trustConfig.moneyFormat || '${{amount}}';
  var secureCheckoutLabel = trustConfig.checkoutLabel || 'Secure checkout';

  /* Intelligems:
     ab-cart-trust — Fuel_06 V1 (trust + custom single upsell)
     ab-cart-trust-restart — [RE] Fuel_06 (trust + native UpCart carousel)
     ab-cart-trust-restart-v2 — [RE] Fuel_06 V2 (trust + custom single upsell) */
  var CART_TRUST_CLASS = 'ab-cart-trust';
  var CART_TRUST_RESTART_CLASS = 'ab-cart-trust-restart';
  var CART_TRUST_RESTART_V2_CLASS = 'ab-cart-trust-restart-v2';

  function isTrustEnabled() {
    var html = document.documentElement;
    return (
      html.classList.contains(CART_TRUST_CLASS) ||
      html.classList.contains(CART_TRUST_RESTART_CLASS) ||
      html.classList.contains(CART_TRUST_RESTART_V2_CLASS)
    );
  }

  function getUpcartDoc() {
    return window.upcartDocumentOrShadowRoot || document;
  }

  function getCartRoot() {
    var doc = getUpcartDoc();
    var root =
      doc.querySelector(
        '#UpcartPopup, #CartPopup, upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, .upcart-cart, .upcart-cart-body, [class*="upcart-cart"]'
      ) || null;

    if (!root && doc && doc.nodeType === 11) root = doc;
    return root;
  }

  function formatMoney(cents) {
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(0, cents) / 100));

    var formatted = moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);

    var container = document.createElement('div');
    container.innerHTML = formatted;
    return container.textContent || '';
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    if (item.final_price === 0 && item.original_price === 0) return true;

    var properties = item.properties || {};
    if (properties._free_product === true || properties._free_product === 'true') return true;

    return false;
  }

  function getDomSearchScopes(root) {
    var doc = getUpcartDoc();
    var scopes = [];

    [root, doc, document].forEach(function (scope) {
      if (!scope || scopes.indexOf(scope) !== -1) return;
      scopes.push(scope);
    });

    return scopes;
  }

  function isFreeGiftDomRow(row) {
    if (!row) return false;
    if (row.closest('#upcart-gifts-summary')) return true;

    var text = (row.textContent || '').toLowerCase();
    return text.indexOf('_free_product') !== -1 || text.indexOf('free gift') !== -1;
  }

  function collectDomCartRows(root, includeGiftRows) {
    var rows = [];
    var seen = [];

    getDomSearchScopes(root).forEach(function (scope) {
      if (!scope || !scope.querySelectorAll) return;

      scope.querySelectorAll(
        '.upcart-product-item, .upcart-cart-item, [data-upcart-item], [class*="product-item"], [class*="ProductRow"]'
      ).forEach(function (row) {
        if (!includeGiftRows && isFreeGiftDomRow(row)) return;
        if (seen.indexOf(row) !== -1) return;
        seen.push(row);
        rows.push(row);
      });
    });

    return rows;
  }

  function rowMatchesCartItem(row, item) {
    var variantId = String(item.variant_id || '');
    var rowVariant =
      row.getAttribute('data-variant-id') ||
      row.dataset.variantId ||
      (row.querySelector('[data-variant-id]') &&
        row.querySelector('[data-variant-id]').getAttribute('data-variant-id')) ||
      '';

    if (rowVariant && String(rowVariant).split(':')[0] === variantId) {
      return true;
    }

    var key = String(item.key || '');
    if (key && (row.id === key || row.getAttribute('data-key') === key || row.dataset.key === key)) {
      return true;
    }

    var titleNeedle = String(item.product_title || item.title || '')
      .split(' - ')[0]
      .trim()
      .toLowerCase();

    if (titleNeedle && (row.textContent || '').toLowerCase().indexOf(titleNeedle) !== -1) {
      return true;
    }

    return false;
  }

  function findDomCartItem(root, item, paidItems, paidIndex) {
    if (!item) return null;

    var rows = collectDomCartRows(root, true);

    for (var i = 0; i < rows.length; i++) {
      if (rowMatchesCartItem(rows[i], item)) {
        return rows[i];
      }
    }

    var paidRows = collectDomCartRows(root, false);
    if (typeof paidIndex === 'number' && paidRows[paidIndex]) {
      return paidRows[paidIndex];
    }

    return null;
  }

  function parseMoneyToCents(text) {
    if (!text) return 0;

    var cleaned = String(text).replace(/[^\d.,]/g, '').trim();
    if (!cleaned) return 0;

    var normalized = cleaned;
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = cleaned.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      var commaParts = cleaned.split(',');
      normalized =
        commaParts.length > 1 && commaParts[commaParts.length - 1].length <= 2
          ? cleaned.replace(',', '.')
          : cleaned.replace(/,/g, '');
    }

    var value = parseFloat(normalized);
    return isNaN(value) ? 0 : Math.round(value * 100);
  }

  function getLineThroughPricesFromDom(row) {
    var prices = [];

    if (!row) return prices;

    row.querySelectorAll('s, del, strike').forEach(function (node) {
      prices.push(parseMoneyToCents(node.textContent));
    });

    row.querySelectorAll('*').forEach(function (node) {
      if (!node.textContent || node.children.length > 0) return;

      try {
        var decoration = window.getComputedStyle(node).textDecorationLine || '';
        if (decoration.indexOf('line-through') !== -1) {
          prices.push(parseMoneyToCents(node.textContent));
        }
      } catch (error) {}
    });

    return prices.filter(function (value) {
      return value > 0;
    });
  }

  function normalizeDomPriceToUnitCents(candidate, finalUnit, qty, finalLine, originalUnit, originalLine) {
    if (!candidate || candidate <= finalUnit) return 0;

    qty = qty || 1;
    finalLine = finalLine != null ? finalLine : finalUnit * qty;
    originalUnit = originalUnit || 0;
    originalLine = originalLine || 0;
    var tolerance = Math.max(100, Math.round(candidate * 0.02));

    if (originalLine > 0 && Math.abs(candidate - originalLine) <= tolerance) {
      return Math.round(originalLine / qty);
    }

    if (originalUnit > finalUnit && Math.abs(candidate - originalUnit) <= tolerance) {
      return originalUnit;
    }

    if (qty > 1) {
      var unitFromLine = Math.round(candidate / qty);
      var matchesLineTotal =
        unitFromLine >= finalUnit && Math.abs(candidate - unitFromLine * qty) <= tolerance;

      if (matchesLineTotal && candidate >= finalUnit * qty * 0.85) {
        return unitFromLine;
      }
    }

    return candidate;
  }

  function parseCompareUnitPriceFromDom(row, finalUnit, qty, finalLine, originalUnit, originalLine) {
    if (!row) return 0;

    qty = qty || 1;
    finalLine = finalLine != null ? finalLine : finalUnit * qty;

    function bestNormalizedUnit(prices) {
      var normalized = prices
        .map(function (price) {
          return normalizeDomPriceToUnitCents(
            price,
            finalUnit,
            qty,
            finalLine,
            originalUnit,
            originalLine
          );
        })
        .filter(function (value) {
          return value > finalUnit;
        });

      return normalized.length ? Math.max.apply(null, normalized) : 0;
    }

    var lineThroughPrices = getLineThroughPricesFromDom(row);
    if (lineThroughPrices.length) {
      return bestNormalizedUnit(lineThroughPrices);
    }

    var priceNodes = row.querySelectorAll(
      '[class*="price"], [class*="Price"], [class*="compare"], [class*="Compare"], [class*="original"], [class*="Original"]'
    );
    var domPrices = [];

    priceNodes.forEach(function (node) {
      var cents = parseMoneyToCents(node.textContent);
      if (cents) domPrices.push(cents);
    });

    if (!domPrices.length) return 0;

    return bestNormalizedUnit(domPrices);
  }

  function getItemReferenceUnitPriceCents(item, domRow) {
    var finalUnit = item.final_price || 0;
    var qty = item.quantity || 1;
    var finalLine = item.final_line_price || finalUnit * qty;
    var originalUnit = item.original_price || 0;
    var originalLine = item.original_line_price || originalUnit * qty;
    var referenceUnit = item._referenceUnitPrice || finalUnit;

    if (item.compare_at_price) {
      referenceUnit = Math.max(referenceUnit, item.compare_at_price);
    }

    if (originalUnit > finalUnit) {
      referenceUnit = Math.max(referenceUnit, originalUnit);
    }

    var domReferenceUnit = parseCompareUnitPriceFromDom(
      domRow,
      finalUnit,
      qty,
      finalLine,
      originalUnit,
      originalLine
    );
    if (domReferenceUnit > finalUnit) {
      referenceUnit = Math.max(referenceUnit, domReferenceUnit);
    }

    return referenceUnit;
  }

  function getDomCompareLinePriceCents(row, finalUnit, qty, finalLine) {
    if (!row) return 0;

    qty = qty || 1;
    finalLine = finalLine != null ? finalLine : finalUnit * qty;
    var lineThroughPrices = getLineThroughPricesFromDom(row);
    if (!lineThroughPrices.length) return 0;

    var best = 0;

    lineThroughPrices.forEach(function (domPrice) {
      if (!domPrice || domPrice <= finalLine) return;

      var asLine = domPrice;

      if (qty > 1) {
        if (domPrice >= finalUnit * qty * 0.75) {
          asLine = domPrice;
        } else if (domPrice >= finalUnit) {
          asLine = domPrice * qty;
        }
      }

      if (asLine > finalLine) {
        best = Math.max(best, asLine);
      }
    });

    return best;
  }

  function getItemReferenceLinePriceCents(item, domRow) {
    var qty = item.quantity || 1;
    var finalUnit = item.final_price || 0;
    var finalLine =
      item.final_line_price != null ? item.final_line_price : finalUnit * qty;
    var originalLine =
      item.original_line_price != null
        ? item.original_line_price
        : (item.original_price || 0) * qty;

    var referenceLine = originalLine;
    var referenceUnit = getItemReferenceUnitPriceCents(item, domRow);

    if (referenceUnit > finalUnit) {
      referenceLine = Math.max(referenceLine, referenceUnit * qty);
    }

    var domLine = getDomCompareLinePriceCents(domRow, finalUnit, qty, finalLine);
    if (domLine > referenceLine) {
      referenceLine = domLine;
    }

    return referenceLine;
  }

  function getItemSavingsCents(item, domRow) {
    var finalUnit = item.final_price || 0;
    var qty = item.quantity || 1;
    var finalLine =
      item.final_line_price != null ? item.final_line_price : finalUnit * qty;
    var referenceLine = getItemReferenceLinePriceCents(item, domRow);

    return Math.max(0, referenceLine - finalLine);
  }

  function getCartSavingsCents(cart, root) {
    if (!cart || !cart.items || !cart.items.length) return 0;

    var savings = 0;

    cart.items.forEach(function (item, index) {
      if (!item) return;

      var domRow = findDomCartItem(root, item, cart.items, index);
      savings += getItemSavingsCents(item, domRow);
    });

    return savings;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  var productPriceCache = {};

  function fetchVariantReferencePrice(item) {
    return new Promise(function (resolve) {
      if (!item.handle) {
        resolve(0);
        return;
      }

      var variantId = String(item.variant_id || '');
      var cachedProduct = productPriceCache[item.handle];

      if (cachedProduct && cachedProduct[variantId]) {
        resolve(cachedProduct[variantId].referenceUnit || 0);
        return;
      }

      fetch('/products/' + item.handle + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (product) {
          var map = {};
          (product.variants || []).forEach(function (variant) {
            var compareAt = variant.compare_at_price || 0;
            var price = variant.price || 0;
            map[String(variant.id)] = {
              price: price,
              compareAt: compareAt,
              referenceUnit: Math.max(compareAt, price)
            };
          });
          productPriceCache[item.handle] = map;
          resolve(map[variantId] ? map[variantId].referenceUnit || 0 : 0);
        })
        .catch(function () {
          resolve(0);
        });
    });
  }

  function enrichCartItemsWithReferencePrices(cart, root) {
    return Promise.all(
      cart.items.map(function (item, index) {
        var domRow = findDomCartItem(root, item, cart.items, index);
        var referenceUnit = getItemReferenceUnitPriceCents(item, domRow);
        var finalUnit = item.final_price || 0;

        if (referenceUnit > finalUnit) {
          item._referenceUnitPrice = referenceUnit;
          return Promise.resolve();
        }

        return fetchVariantReferencePrice(item).then(function (referenceFromProduct) {
          if (referenceFromProduct > finalUnit) {
            item._referenceUnitPrice = referenceFromProduct;
          }
        });
      })
    );
  }

  function findCheckoutButton(root) {
    var doc = getUpcartDoc();
    var scopes = [root];

    if (doc !== document && doc.querySelector) scopes.push(doc);

    var selectors = [
      '.upcart-checkout-button',
      'button.upcart-checkout-button',
      'a.upcart-checkout-button',
      'button[class*="CheckoutButton"]',
      'a[class*="CheckoutButton"]',
      'button[class*="checkout-button"]',
      'a[class*="checkout-button"]',
      'button[class*="checkoutButton"]',
      'a[class*="checkoutButton"]',
      '[class*="CheckoutButton"] button',
      '[class*="checkout-button"] button',
      'button[type="submit"][name="checkout"]',
      '#CartDrawer-Checkout',
      'button[name="checkout"]'
    ];

    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope || !scope.querySelectorAll) continue;

      for (var i = 0; i < selectors.length; i++) {
        var match = scope.querySelector(selectors[i]);
        if (match) return match;
      }

      var candidates = scope.querySelectorAll('button, a[role="button"], a.button, a[class*="button"]');
      for (var j = 0; j < candidates.length; j++) {
        var text = (candidates[j].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (
          text.indexOf('continue order') !== -1 ||
          text.indexOf('proceed to checkout') !== -1 ||
          text === 'checkout' ||
          text.indexOf('check out') !== -1
        ) {
          return candidates[j];
        }
      }
    }

    return null;
  }

  function findSubtotalAnchor(root) {
    var doc = getUpcartDoc();
    var scopes = [root];

    if (doc !== document && doc.querySelector) scopes.push(doc);

    var selectors = [
      '[class*="Subtotal"]',
      '[class*="subtotal"]',
      '[data-subtotal]',
      '[id*="subtotal"]'
    ];

    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope || !scope.querySelectorAll) continue;

      for (var i = 0; i < selectors.length; i++) {
        var match = scope.querySelector(selectors[i]);
        if (match) return match;
      }

      var nodes = scope.querySelectorAll('div, span, p, li, td, th, label, strong');
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^subtotal\b/i.test(text) || /\bsubtotal\b/i.test(text)) {
          return node.closest('[class*="row"], [class*="Row"], [class*="line"], li, tr, div') || node;
        }
      }
    }

    return null;
  }

  function removeElementById(id) {
    [document, getUpcartDoc()].forEach(function (doc) {
      if (!doc || !doc.getElementById) return;
      var element = doc.getElementById(id);
      if (element) element.remove();
    });
  }

  function getCheckoutButtonLabel(button) {
    return (button.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function setCheckoutButtonLabel(button, label) {
    if (!button || !label) return;

    var labelTarget =
      button.querySelector(
        '[class*="checkout"] span, [class*="Checkout"] span, [class*="label"], [class*="Label"], [class*="text"], [class*="Text"], span, p'
      ) || button;

    if (labelTarget !== button && (labelTarget.querySelector('svg, img') || !labelTarget.textContent.trim())) {
      labelTarget = button;
    }

    if (labelTarget === button) {
      Array.prototype.slice.call(button.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.trim()) {
          node.textContent = label;
        }
      });

      if (getCheckoutButtonLabel(button) !== label) {
        button.textContent = label;
      }

      return;
    }

    labelTarget.textContent = label;
  }

  function updateCheckoutButtonLabel(checkoutButton) {
    if (!checkoutButton) return;

    if (!checkoutButton.dataset.upcartTrustOriginalLabel) {
      checkoutButton.dataset.upcartTrustOriginalLabel = getCheckoutButtonLabel(checkoutButton);
    }

    setCheckoutButtonLabel(checkoutButton, secureCheckoutLabel);
  }

  function restoreCheckoutButtonLabels(root) {
    getDomSearchScopes(root || getCartRoot()).forEach(function (scope) {
      if (!scope || !scope.querySelectorAll) return;

      scope.querySelectorAll('[data-upcart-trust-original-label]').forEach(function (button) {
        var originalLabel = button.dataset.upcartTrustOriginalLabel;
        if (originalLabel) {
          setCheckoutButtonLabel(button, originalLabel);
        }
        button.removeAttribute('data-upcart-trust-original-label');
      });
    });
  }

  function removeTrustUi() {
    removeElementById(BADGE_ID);
    removeElementById(SAVINGS_ID);
    restoreCheckoutButtonLabels();
  }

  function ensureBadge(checkoutButton) {
    if (!checkoutButton || !trustImageUrl) return null;

    var doc = checkoutButton.ownerDocument || document;
    var existing = doc.getElementById(BADGE_ID);
    if (existing) {
      if (existing.previousElementSibling !== checkoutButton) {
        checkoutButton.insertAdjacentElement('afterend', existing);
      }
      return existing;
    }

    var badge = doc.createElement('div');
    badge.id = BADGE_ID;
    badge.className = 'upcart-cart-trust-badge';

    var img = doc.createElement('img');
    img.src = trustImageUrl;
    img.alt = 'Accepted payment methods';
    img.width = 792;
    img.height = 59;
    img.loading = 'lazy';
    img.decoding = 'async';

    badge.appendChild(img);
    checkoutButton.insertAdjacentElement('afterend', badge);
    return badge;
  }

  function ensureSavings(subtotalAnchor, savingsCents) {
    if (!subtotalAnchor || savingsCents <= 0) {
      removeElementById(SAVINGS_ID);
      return null;
    }

    var doc = subtotalAnchor.ownerDocument || document;
    var existing = doc.getElementById(SAVINGS_ID);
    var savings = existing;

    if (!savings) {
      savings = doc.createElement('div');
      savings.id = SAVINGS_ID;
      savings.className = 'upcart-cart-savings';
      subtotalAnchor.insertAdjacentElement('beforebegin', savings);
    } else if (savings.nextElementSibling !== subtotalAnchor) {
      subtotalAnchor.insertAdjacentElement('beforebegin', savings);
    }

    savings.textContent = 'You saved ' + formatMoney(savingsCents);
    savings.hidden = false;
    return savings;
  }

  function renderCartTrust(retryCount) {
    retryCount = retryCount || 0;

    if (!isTrustEnabled()) {
      removeTrustUi();
      pauseObserver();
      return;
    }

    if (isRendering) return;
    isRendering = true;

    var root = getCartRoot();
    if (!root) {
      isRendering = false;
      waitForCartRoot();
      return;
    }

    fetchCart()
      .then(function (cart) {
        if (!isTrustEnabled()) {
          removeTrustUi();
          return null;
        }

        return enrichCartItemsWithReferencePrices(cart, root).then(function () {
          return cart;
        });
      })
      .then(function (cart) {
        if (!cart || !isTrustEnabled()) {
          removeTrustUi();
          return;
        }

        var savingsCents = getCartSavingsCents(cart, root);
        var subtotalAnchor = findSubtotalAnchor(root);

        if (subtotalAnchor && savingsCents > 0) {
          ensureSavings(subtotalAnchor, savingsCents);
        } else {
          removeElementById(SAVINGS_ID);
          if (retryCount < 3 && cart.items.length) {
            setTimeout(function () {
              renderCartTrust(retryCount + 1);
            }, 350);
          }
        }

        var checkoutButton = findCheckoutButton(root);
        if (checkoutButton) {
          updateCheckoutButtonLabel(checkoutButton);
          if (trustImageUrl) {
            ensureBadge(checkoutButton);
          } else {
            removeElementById(BADGE_ID);
          }
        } else {
          removeElementById(BADGE_ID);
        }

        resumeObserver();
      })
      .catch(function () {
        removeTrustUi();
      })
      .finally(function () {
        isRendering = false;
      });
  }

  function scheduleRender() {
    if (!isTrustEnabled()) {
      removeTrustUi();
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(renderCartTrust, 150);
  }

  function pauseObserver() {
    if (observer) observer.disconnect();
  }

  function resumeObserver() {
    if (!observer || !isTrustEnabled()) return;

    var root = getCartRoot();
    if (!root) return;

    try {
      observer.observe(root, { childList: true, subtree: true });
    } catch (error) {}
  }

  function bindObserver() {
    if (observer) {
      resumeObserver();
      return;
    }

    observer = new MutationObserver(function () {
      if (isRendering || !isTrustEnabled()) return;
      scheduleRender();
    });

    resumeObserver();
  }

  function waitForCartRoot() {
    if (getCartRoot()) {
      bindObserver();
      scheduleRender();
      return;
    }

    if (drawerFinder) return;

    drawerFinder = setInterval(function () {
      if (!isTrustEnabled()) return;

      if (getCartRoot()) {
        clearInterval(drawerFinder);
        drawerFinder = null;
        bindObserver();
        scheduleRender();
      }
    }, 500);
  }

  function interceptFetchCartChanges() {
    if (window._upcartCartTrustFetchHooked) return;
    window._upcartCartTrustFetchHooked = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var firstArg = arguments[0];
      var url = typeof firstArg === 'string' ? firstArg : firstArg && firstArg.url ? firstArg.url : '';

      return originalFetch.apply(this, arguments).then(function (response) {
        if (
          typeof url === 'string' &&
          /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url)
        ) {
          setTimeout(scheduleRender, url.indexOf('/cart/add') !== -1 ? 300 : 50);
        }
        return response;
      });
    };
  }

  function syncExperimentState() {
    if (isTrustEnabled()) {
      waitForCartRoot();
      scheduleRender();
    } else {
      removeTrustUi();
      pauseObserver();
      if (drawerFinder) {
        clearInterval(drawerFinder);
        drawerFinder = null;
      }
    }
  }

  interceptFetchCartChanges();

  document.addEventListener('click', function (event) {
    if (!isTrustEnabled()) return;

    var target = event.target;
    if (!target || !target.closest) return;

    if (
      target.closest('#cart-icon-bubble, [data-nuora-upcart-trigger], .header__icon--cart') ||
      target.closest('#UpcartPopup, #CartPopup, #upCart, .upcart-cart, [class*="UpcartPopup"]')
    ) {
      setTimeout(scheduleRender, 500);
    }
  }, true);

  document.addEventListener('upcart_updated', scheduleRender);

  new MutationObserver(syncExperimentState).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncExperimentState);
  } else {
    syncExperimentState();
  }
})();
